import React, { Component } from 'react';

class WebRtcAxiaIQs extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        return ( <>Axia iQs - {this.props.item.inviteName}</> );
    }
}
 
export default WebRtcAxiaIQs